import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.2 32.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.1 22.1c6.2-3.6 10.3-8.9 11.4-12.7.4-1.3.4-2.5 0-3.3-.5-.8-1.1-1.3-2.6-1.4l1.9 3.4c-.6 3.2-4.7 8.1-11.7 12.1L0 24.3l7.1-12.2-7.1-4h14V0l2.4 4.1c1.8 0 3 .6 3.7 1.6.7 1 1 2.6.2 5.2l.7 1.3 6.9-4-7 12.1 7.1 4.1H13.9v8L8 22.1Z",
      style: {"fill":"#f47721"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "6H-logo"}) } }